//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: 'payment-code',
    components: {},
    data() {
        return {
            value: '',
            showKeyboard: true,
            saving: false
        };
    },
    methods: {
        onInput(key) {
            this.value = (this.value + key).slice(0, 6);
        },
        onDelete() {
            this.value = this.value.slice(0, this.value.length - 1);
        },
        savePwd() {
            if (!/^\S{6,6}$/.test(this.value)) {
                this.$toast('请输入6位密码');
                return;
            }
            var params = {
                paymentCode: this.value
            };
            this.saving = true;
            abp.ajax.put('/api/services/app/Member/UpdatePaymentPassWord', params).then(res => {
                console.log(res.data.result);
                this.$toast.success('保存成功');
                this.$router.go(-1);
            }).finally(() => {
                this.saving = false;
            });
        }
    },
    created() {
    }
};
